<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <h2 class="FiveBlockLinksForDriving-h2">{{ contents.heading.text }}</h2>
              <p class="FiveBlockLinksForDriving-p">{{ contents.paragraph.text }}</p>
              <ul class="FiveBlockLinksForDriving-list flex justify-center items-center theme-accent-border-color" :style="contents.theme.isCustom ? 'border-color:' + contents.theme.color : ''">
                <template v-for="(item, i) in contents.links">
                  <template v-if="item.pageId">
                    <li class="FiveBlockLinksForDriving-item theme-accent-border-color" :style="contents.theme.isCustom ? 'border-color:' + contents.theme.color : ''"><a :class="['FiveBlockLinksForDriving-a', 'theme-accent-bg-color-hover', contents.theme.isCustom ? 'FiveBlockLinksForDriving-' + _uid + '-a-bg-color-hover': '']"><i :class="['fa', ' fa-' + item.icon]" aria-hidden="true"></i>{{ getPageById(item.pageId).title.rendered }}</a></li>
                  </template>
                </template>
              </ul>
            </div>
          </section>

        </div>
      </div>
      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="見出し" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.heading.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="段落" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.paragraph.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="リンク" :label-width="labelWidth">
          <template v-for="(item, index) in contents.links">
            <div>
              <el-select class="width-20" v-model="contents.links[index].icon" placeholder="アイコンリストから選択" style="display:inline-block;">
                <el-option class="el-opp"
                  v-for="icon in icons"
                  :key="icon.value"
                  :label="icon.label"
                  :value="icon.value">
                  <span style="display:inline-block;width:2em">
                    <i :class="['fa', ' fa-' + icon.value]" aria-hidden="true" style="font-size:1.5em;"></i>
                  </span>
                  <span style="float:right">{{ icon.value }}</span>
                </el-option>
              </el-select>
              <el-select class="width-50" value-key="link" v-model="contents.links[index].pageId" placeholder="固定ページから選択" style="display:inline-block;">
                <el-option class="el-opp"
                  v-for="page in publishedPages"
                  :key="page.link"
                  :label="page.title.rendered"
                  :value="page.id">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="ボーダー・ホバー背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.theme.isCustom">ボーダー・ホバー背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.theme.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.theme.color" show-alpha @change="onThemeChange"></el-color-picker>
            <span>{{ contents.theme.color }}</span>
          </div>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import SelectLinks from '@/components/forms/SelectLinks'
import {getFontawesomeIcons} from '@/helpers'

export default {
  name: 'five-block-links',
  components: {
    'select-links': SelectLinks
  },
  mixins: [ComponentBase],
  data () {
    return {
      labelWidth: '120px',
      icons: getFontawesomeIcons()
      // icons: [
      //   'car', 'motorcycle', 'truck', 'taxi', 'id-card'
      // ]
    }
  },
  methods: {
    getCssForThemeColors: function () {
      return `.${this.meta.file}-${this._uid}-a-bg-color-hover:hover {background-color: ${this.contents.theme.color}}`
    },
    onThemeChange: function (value) {
      const head = document.head
      const style = document.createElement('style')
      style.type = 'text/css'
      if (style.styleSheet) {
        style.styleSheet.cssText = this.getCssForThemeColors()
      } else {
        style.appendChild(document.createTextNode(this.getCssForThemeColors()))
      }
      head.appendChild(style)
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const borderClass = contents.theme.isCustom ? `${this.meta.file}-${this._uid}-border` : ''
      const hoverClass = contents.theme.isCustom ? `${this.meta.file}-${this._uid}-a-bg-color-hover` : ''
      let linksHtml = ''
      if (contents.links.reduce((prev, curr) => curr.pageId ? prev + 1 : prev, 0) > 0) {
        linksHtml += `<ul class="${this.meta.file}-list flex justify-center items-center theme-accent-border-color ${borderClass}">`
        contents.links.forEach(item => {
          linksHtml += `<li class="${this.meta.file}-item theme-accent-border-color ${borderClass}"><a class="${this.meta.file}-a theme-accent-bg-color-hover ${hoverClass}" href="${this.getPageById(item.pageId).link}"><i class="fa fa-${item.icon}" aria-hidden="true"></i>${this.getPageById(item.pageId).title.rendered}</a></li>`
        })
        linksHtml += `</ul>`
      }
      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <h2 class="${this.meta.file}-h2">${contents.heading.text}</h2>
          <p class="${this.meta.file}-p">${contents.paragraph.text}</p>
          ${linksHtml}
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = ''
      if (contents.bg.isCustom) {
        theme += `.${this.meta.file}-${this._uid}-bg {background-color:${contents.bg.color}}`
      }
      if (contents.theme.isCustom) {
        theme += `.${this.meta.file}-${this._uid}-border {border-color: ${this.contents.theme.color}}`
        theme += this.getCssForThemeColors()
      }
      return {layout, theme}
    }
  },
  created: function () {
    this.onThemeChange()

    // migration
    if (!this.contents.padding) this.contents.padding = {y: 4}
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './FiveBlockLinksForDriving.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './FiveBlockLinksForDriving.s.scss';
}
.tablet,
.desktop {
  @import './FiveBlockLinksForDriving.m.scss';
}
.desktop {
  @import './FiveBlockLinksForDriving.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.vue